export function setLoadingMessage(state, payload) {
  state.loadingMessage = payload;
}
export function setNotification(state, payload) {
  state.notification = payload;
}
